import { CleanSchema, get } from '../json-transform';

export const getActivitiesQS = new CleanSchema({
  date_after: get('date_after').asISOString().asArrayOf().ifEmpty(undefined),
  date_before: get('date_before').asISOString().asArrayOf().ifEmpty(undefined),
  user: get('user').asArrayFromString().ifEmpty(undefined),
  action: get('action').asArrayFromString().ifEmpty(undefined),
  content_type: get('content_type').asArrayFromString().ifEmpty(undefined),
});
